<template>
    <div class="d-flex" v-if="params.data.response_id">
        <b-button class="mr-2" variant="default" @click="editResponse">
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <b-button variant="default" @click="$bvModal.show(removeModalId)" v-if="!params.data.is_default">
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <b-button v-else variant="default" @click="$bvModal.show(resetModalId)">
            <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" />
        </b-button>
        <modal
            :id="resetModalId"
            title="Reset Response
"
            @ok.prevent="onReset"
        >
            Are you sure you want to reset "{{ params.data.title }}"?
        </modal>
        <modal
            :id="removeModalId"
            title="Delete Response
"
            @ok.prevent="onRemove"
        >
            Are you sure you want to delete "{{ params.data.title }}"?
        </modal>
    </div>
</template>

<script>
import Modal from '../generic/modal/modal.vue';
export default {
    components: {
        Modal,
    },
    computed: {
        resetModalId() {
            return `reset-modal-${this.params.data.response_id}`;
        },
        removeModalId() {
            return `remove-modal-${this.params.data.response_id}`;
        },
    },
    methods: {
        hideRemoveModal() {
            this.$bvModal.hide(this.removeModalId);
        },
        hideResetModal() {
            this.$bvModal.hide(this.resetModalId);
        },
        onRemove() {
            this.params.onRemove &&
                this.params.onRemove(this.params.data.response_id, this.hideRemoveModal, this.params.data.title);
        },
        onReset() {
            this.params.onReset &&
                this.params.onReset(this.params.data.response_id, this.hideResetModal, this.params.data.title);
        },
        editResponse() {
            this.$router.push(`/app/responses/edit/${this.params.data.response_id}`);
        },
    },
};
</script>

<style>
</style>